import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { ReportModules } from '../Data/ReportModules';
import Home from '../Components/HomeReport'

const drawerWidth = 240;
function ReportModule(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const [selectedComponent, setSelectedComponent] = React.useState(Home);

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const drawer = (
        <Box
            sx={{
                width: 257, background: '#9E1713', height: 'calc(100vh - 5vh)',
            }}
        >
            <List
                sx={{
                    maxHeight: 'calc(100vh - 10vh)',
                    overflowY: 'auto',
                }}>
                {ReportModules.map(({ id, name, icon, component: Component }) => (
                    <ListItem key={id} disablePadding>
                        <ListItemButton onClick={() => {
                            setSelectedComponent(<Component />);
                            handleDrawerClose();
                        }}>
                            <ListItemIcon sx={{ color: 'white' }}>
                                {icon}
                            </ListItemIcon>
                            <ListItemText
                                primaryTypographyProps={{
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontFamily: 'Kanit, sans-serif'
                                }} primary={name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box >
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            paddingTop: 7,
        }}>
            <CssBaseline />
            <Toolbar
                sx={{
                    position: 'fixed',
                    background: { xs: 'white', md: 'none' },
                    width: { xs: '100%', md: 'auto' },
                }} >
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ display: { sm: 'none' } }}
                >
                    <MenuOpenIcon sx={{ fontSize: '40px' }} />
                </IconButton>
            </Toolbar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, mt: 7, },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, mt: 7, },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, width: { sm: 'calc(100% - 260px)' }, marginTop: { xs: 5, sm: 0 } }}
            >
                {selectedComponent}
            </Box>
        </Box>
    );
}

ReportModule.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * Remove this when copying and pasting into your project.
     */
    window: PropTypes.func,
};

export default ReportModule;
